import InputTypesEnum from '../../../Enums/InputTypesEnum';
import EvaluatorItem from './EvaluatorItem';
import EvaluatorService from '../../../Services/EvaluatorService';

// Drives the GeneralEditWizzardBaseFigma edit wizard for evaluator information.
// Edit-only, single page with <=6 fields -> compact centered DS modal. No
// entityName is set so the composed titleForEdit (with the evaluator's name)
// wins as the header title.
export default class EvaluatorWindowDescription {
  static titleForCreate = (item) => EvaluatorWindowDescription.composeTitle(item);
  static titleForEdit = (item) => EvaluatorWindowDescription.composeTitle(item);
  static itemType = EvaluatorItem;
  static serviceFunction = EvaluatorService.EditEvaluator;
  static messageOnSuccess = 'Evaluator information has been saved.';
  static finishButtonLabel = 'Save Evaluator';

  static composeTitle(item) {
    return `Edit Evaluator Information (${item?.EvFirstName ?? ''} ${item?.EvLastName ?? ''})`;
  }

  static getVatTypeValues() {
    return [
      { label: 'No VAT', value: 'No VAT', disabled: false },
      { label: 'Fee Only', value: 'Fee Only', disabled: false },
      { label: 'Fee and Expenses', value: 'Fee and Expenses', disabled: false },
    ];
  }

  static getPaymentMethodValues(item) {
    if (item.EvPaymentOfficeName === 'BARE US') {
      switch (item.EvCountry) {
        case 'US':
          return [
            { label: 'Direct Deposit', value: 'DirectDeposit', disabled: false },
            { label: 'Check', value: 'Check', disabled: false },
            { label: 'Tipalti', value: 'Tipalti', disabled: false },
          ];
        case 'CA':
          return [
            { label: 'Direct Deposit', value: 'D', disabled: false },
            { label: 'Check', value: 'C', disabled: false },
            { label: 'International', value: 'I', disabled: false },
            { label: 'Tipalti', value: 'T', disabled: false },
          ];
        default:
          return [
            { label: 'International', value: 'I', disabled: false },
            { label: 'Tipalti', value: 'T', disabled: false },
          ];
      }
    }
    return [{ label: 'International', value: 'I', disabled: false }];
  }

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'EvPaymentMethod',
          label: 'Payment Method',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: (item) => EvaluatorWindowDescription.getPaymentMethodValues(item),
        },
        {
          fieldName: 'EvVatType',
          label: 'VAT Type',
          className: 'col-6',
          type: InputTypesEnum.Select,
          selectvalues: () => EvaluatorWindowDescription.getVatTypeValues(),
        },
        {
          fieldName: 'EvTransactionMethod',
          label: 'Transaction Method',
          className: 'col-6',
          type: InputTypesEnum.Text,
        },
        {
          fieldName: 'EvIsAgency',
          label: 'Agency',
          className: 'col-6',
          type: InputTypesEnum.Bool,
        },
      ],
    },
  ];
}
